import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import { LwFormInput } from 'redesign';
import { EmployeeMutableUntilHoursFieldProps } from './employee-mutable-until-hours-field.types';

export const EmployeeMutableUntilHoursField = ({
  control,
  name,
  label,
  placeholder,
}: EmployeeMutableUntilHoursFieldProps) => {
  return (
    <FormFieldContainer>
      <LwFormInput
        name={name}
        inputType="number"
        control={control}
        label={label}
        placeholder={placeholder}
        rules={{
          required: 'Voer een fee in',
          min: {
            value: 0,
            message: 'Min is 0',
          },
        }}
      />
    </FormFieldContainer>
  );
};

const FormFieldContainer = styled(Box)(() => ({
  maxWidth: '400px',
  width: '100%',
}));
